import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "indu-tree-container"
};
import { api } from '@/server';
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'industryTree',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [Object, Array],
      default: () => ({
        id: '',
        name: ''
      })
    }
  },
  emits: ['select', 'update:selected'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const idMap = ref({});
    const dataSource = ref([]);
    const selections = ref();
    const isMultiple = computed(() => props.multiple);
    watch(() => props.selected, val => {
      if (isMultiple.value) {
        // 多选
        const rows = [];
        for (const id of val) {
          const item = idMap.value[id];
          if (!item) continue;
          rows.push(item);
        }
        selections.value = rows;
      } else {
        // 单选
        selections.value = idMap.value[val] || {
          id: '',
          name: ''
        };
      }
    }, {
      deep: true,
      immediate: true
    });
    const {
      runAsync: getIndustryTree
    } = fetchApi(api.industry.getTree);
    const loadIndustries = async () => {
      const {
        error,
        rows
      } = await getIndustryTree({
        maxLevel: 3,
        search: ''
      });
      if (error) return;
      const maps = {};
      const transformSub = subItems => {
        if (!subItems) return subItems;
        return subItems.map(subItem => {
          const {
            id,
            childCount,
            children,
            ...more
          } = subItem;
          const treeNode = {
            id,
            disabled: childCount > 0,
            childCount,
            selectable: childCount === 0 || (children || []).length === 0,
            children: transformSub(children),
            ...more
          };
          maps[id] = treeNode;
          return treeNode;
        });
      };
      dataSource.value = rows.map(item => {
        const {
          id,
          childCount,
          children,
          ...more
        } = item;
        const treeNode = {
          id,
          disabled: childCount > 0,
          childCount,
          selectable: childCount === 0 || (children || []).length === 0,
          children: transformSub(children),
          ...more
        };
        maps[id] = treeNode;
        return treeNode;
      });
      idMap.value = maps;
    };
    const fieldNames = reactive({
      title: 'name',
      key: 'id',
      children: 'children',
      disabled: 'disabled'
    });
    const filterTreeNode = node => {
      // 多选
      if (isMultiple.value) {
        const rows = selections.value || [];
        return rows.findIndex(t => t.id === node.id) !== 1;
      }
      // 单选
      const {
        id: oldId = ''
      } = selections.value || {};
      const {
        id: curId = ''
      } = node || {};
      return oldId === curId;
    };
    const handleSelect = (_, {
      selected,
      node
    }) => {
      if (isMultiple.value) {
        const rows = selected.value.slice();
        if (selected) {
          rows.push(node);
        } else {
          const idx = rows.findIndex(t => t.id === node.id);
          if (idx === -1) return;
          rows.splice(idx, 1);
          selections.value = rows;
        }
        emit('update:selected', rows.map(t => t.id));
        emit('select', selections.value);
        return;
      }
      // single select
      selections.value = node;
      emit('update:selected', selections.value.id);
      emit('select', selections.value);
    };
    onMounted(() => {
      nextTick(async () => {
        await loadIndustries();
      });
    });
    return (_ctx, _cache) => {
      const _component_a_tree = _resolveComponent("a-tree");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tree, {
        "field-names": fieldNames,
        "tree-data": dataSource.value,
        "filter-tree-node": filterTreeNode,
        "show-line": "",
        "default-expand-all": "",
        onSelect: handleSelect
      }, null, 8, ["field-names", "tree-data"])]);
    };
  }
};